import { ref } from 'vue';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const globalOptions = ref({});

const alertIconColors = {
	question:
		'var(--studio-accent-text, var(--bs-theme, #1f6bff))',
	info: 'var(--studio-info-text, var(--bs-info, #299cdb))',
	success: 'var(--studio-success-text, var(--bs-success, #0ab39c))',
	warning: 'var(--studio-warning-text, var(--bs-warning, #f7b84b))',
	error: 'var(--studio-danger-text, var(--bs-danger, #f06548))',
};

const getAlertIconColor = icon =>
	alertIconColors[icon] || alertIconColors.question;

export const alert = (
	message,
	title,
	icon,
	options,
	callback,
	callbackParams
) => {
	console.log('callback', callback);
	return new Promise(resolve => {
		const mixedOptions = {
			...globalOptions.value,
			...options,
		};
		mixedOptions.title = title || mixedOptions.title;
		mixedOptions.text = message || mixedOptions.text;
		mixedOptions.icon = icon || mixedOptions.icon;
		mixedOptions.iconColor =
			mixedOptions.iconColor || getAlertIconColor(mixedOptions.icon);

		Swal.fire(mixedOptions)
			.then(result => {
				if (result.value === true) {
					// 檢查是否按下了確定按鈕
					if (callback) {
						callback(callbackParams); // 執行 callback 函式並傳入參數
					}
					resolve(true);
				} else {
					resolve(false); // 可以根據實際情況決定是否需要這個分支
				}
			})
			.catch(() => {
				resolve(false); // 在出錯時解析為 false 或其他適合的處理方式
			});
	});
};

export const confirm = (
	message,
	title,
	icon,
	options,
	callback,
	callbackParams
) => {
	return new Promise((resolve, reject) => {
		const mixedOptions = {
			...globalOptions.value,
			...options,
		};
		mixedOptions.title = title || mixedOptions.title;
		mixedOptions.text = message || mixedOptions.text;
		mixedOptions.icon = icon || 'question';
		mixedOptions.iconColor =
			mixedOptions.iconColor || getAlertIconColor(mixedOptions.icon);
		mixedOptions.showCancelButton = true;

		Swal.fire(mixedOptions)
			.then(result => {
				if (result.value === true) {
					// 如果使用者按下了確定按鈕
					if (callback) {
						callback(callbackParams); // 執行 callback 函式並傳入參數
					}
					resolve(true); // 解析 promise 為 true
				} else {
					resolve(false); // 如果按下了取消按鈕，或者彈窗以其他方式被關閉
				}
			})
			.catch(() => {
				reject(); // 在出錯時拒絕 promise
			});
	});
};

export const prompt = (
	message,
	defaultText,
	title,
	icon,
	options,
	callback
) => {
	return new Promise((resolve, reject) => {
		const mixedOptions = {
			...globalOptions.value,
			...options,
		};
		mixedOptions.title = title || mixedOptions.title;
		mixedOptions.inputValue = defaultText;
		mixedOptions.text = message || mixedOptions.text;
		mixedOptions.icon = icon || mixedOptions.icon;
		mixedOptions.iconColor =
			mixedOptions.iconColor || getAlertIconColor(mixedOptions.icon);
		mixedOptions.showCancelButton = true;
		mixedOptions.input = mixedOptions.input || 'text';

		Swal.fire(mixedOptions)
			.then(result => {
				if (result.value !== undefined) {
					// 用户按下了确定按鈕
					if (callback) {
						callback(result.value); // 執行 callback 函数, 並傳遞輸入值
					}
					resolve(result.value); // 解析 Promise 为用户输入的值
				} else {
					// 用户按下了取消按鈕
					resolve(null); // 解析 Promise 为 null
				}
			})
			.catch(() => {
				reject(); // 在出錯時拒絕 promise
			});
	});
};

export const fire = options => {
	return Swal.fire(options);
};

export const install = (app, options) => {
	globalOptions.value = options;

	// Global properties
	app.config.globalProperties.$alert = alert;
	app.config.globalProperties.$confirm = confirm;
	app.config.globalProperties.$prompt = prompt;
	app.config.globalProperties.$fire = fire;

	// Instance properties
	app.provide('$alert', alert);
	app.provide('$confirm', confirm);
	app.provide('$prompt', prompt);
	app.provide('$fire', fire);
};

export default { install };
